import React from "react";
import { Modal, ModalBody } from "reactstrap";
import styles from "./styles.module.scss";
const DeleteRewardItemModal = ({ openModal, toggle, deleteReward }) => {
  return (
    <>
      <Modal
        isOpen={openModal}
        toggle={() => {
          toggle();
        }}
        centered
        fullscreen="sm"
        contentClassName={styles["modal_content"]}
        className={styles["modal_product_container"]}
        wrapClassName={styles["modal_wrapper"]}
      >
        <ModalBody className={styles["modal_location_body"]}>
          <div className={styles["modal_add_reward_header"]}>
            <h2 className={styles["modal_add_reward_header_title"]}>
              Are you sure you want to delete this reward?
            </h2>
            <p className={styles["modal_add_reward_header_description"]}>
              This action cannot be undone.
            </p>
          </div>

          <div className={styles._button_wrapper}>
            <button className={styles._cancel_button} onClick={toggle}>
              Cancel
            </button>
            <button className={styles._save_button} onClick={deleteReward}>
              Delete
            </button>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default DeleteRewardItemModal;
